import React, { useEffect, useState } from "react";
import { Modal, Button, notification, Select, Typography, Transfer } from "antd";
import axiosInstance from "utilities/axios";


const { Text } = Typography;

const ChangeRegionDivision = ({ division, visible, setVisible, onChange }) => {
  const [regionOptions, setRegionOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);

  const [selectedDivision, setSelectedDivision] = useState(null);
  const [targetKeys, setTargetKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);

  useEffect(() => {
    axiosInstance
      .get("/divisions")
      .then((response) => {
        const filteredDivisions = response.data.filter((d) => d.divisionCode !== division.divisionCode);

        setDivisionOptions(filteredDivisions);
      });

      setRegionOptions(division.regions);
  }, [division]);

  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const handleDivisionSelect = (value) => {
    setSelectedDivision(value);

    axiosInstance
      .get(`/divisions/${value}`)
      .then((response) => {
        setTargetKeys(response.data.regions.map((region) => region.regionCode));

        setRegionOptions(response.data.regions.concat(division.regions));
      })
      .catch((err) => {
        notification.error({
          message: "Error Fetching Regions",
          description: err.response.data.error,
        });
      });
  };

  const handleTransferChange = (nextTargetKeys) => {
    setTargetKeys(nextTargetKeys);
  };

  const handleSubmit = () => {
    axiosInstance
      .put(`/divisions/${selectedDivision}/regions`, {
        regions: targetKeys,
      })
      .then((response) => {
        return axiosInstance.put(`/divisions/${division.divisionCode}/regions`, {
          regions: regionOptions
            .filter((region) => !targetKeys.includes(region.regionCode))
            .map((region) => region.regionCode),
        });
      })
      .then((response) => {
        notification.success({
          message: "Region Division Updated",
        });
        onChange();
        resetModal();
      })
      .catch((error) => {
        notification.error({
          message: "Error Updating Region(s) Division",
          description: error.response.data.error,
        });
      });
  };

  const resetModal = () => {
    setSelectedDivision(null);
    setRegionOptions(division.regions);
    setVisible(false);
    setTargetKeys([]);
  };

  return (
    <Modal
      title="Change Region Division"
      open={visible}
      onCancel={() => {
        resetModal();
      }}
      footer={null}
    >
      <div className="mt-4 flex flex-col">
        <Text>New Region</Text>
        <Select
          placeholder="Select New Division"
          value={selectedDivision}
          onChange={handleDivisionSelect}
          style={{ marginBottom: 16 }}
        >
          {divisionOptions.map((division) => (
            <Select.Option key={division.divisionCode} value={division.divisionCode}>
              {division.divisionCode} - {division.divisionName}
            </Select.Option>
          ))}
        </Select>
        <Transfer
          dataSource={regionOptions}
          targetKeys={targetKeys}
          selectedKeys={selectedKeys}
          rowKey={(record) => record.regionCode}
          onSelectChange={onSelectChange}
          onChange={handleTransferChange}
          render={(item) => `${item.regionCode} - ${item.regionName}`}
          disabled={!selectedDivision}
          listStyle={{ width: "45%", height: 300 }}
          style={{ width: "100%", marginBottom: 20 }}
          titles={[division.divisionCode, selectedDivision]}
          locale={{ itemUnit: "Region", itemsUnit: "Regions" }}
        />
      </div>
      <div style={{ marginTop: 16 }} className="flex justify-end gap-2">
        <Button onClick={() => resetModal()}>Cancel</Button>
        <Button type="primary" onClick={handleSubmit}>Save</Button>
      </div>
    </Modal>
  );
};

export default ChangeRegionDivision;